<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosAnuais' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Anual
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn depressed color="primary" @click="() => [visualizarPdf(plano.id), (dialog = true)]">
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input>
              {{ plano.gestao_de_aula.professor ? plano.gestao_de_aula.professor.nome : "- - - " }}
            </v-input>

            <label for="">Turma</label>
            <v-input>
              {{ plano.gestao_de_aula.turma ? plano.gestao_de_aula.turma.descricao : "- - - " }}
            </v-input>
            <label for="">Disciplina</label>
            <v-input>
              {{
                plano.gestao_de_aula?.disciplina?.descricao
                  ? plano.gestao_de_aula?.disciplina?.descricao
                  : "- - - "
              }}
            </v-input>

            <label for="">Data lançamento</label>
            <v-input>
              <v-chip>
                {{
                  plano ? plano.created_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Ultima atualização</label>
            <v-input>
              <v-chip>
                {{
                  plano ? plano.updated_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox v-model="seriesSelecionadas" chips label="Series" multiple readonly />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="10" md="6" lg="4" xl="2">
                <label for="">Status</label>
                <e-situacao-plano-anual
                  :plano="plano"
                  v-on:update="listarPlano"
                  v-on:close-modal="dialog = false"
                />
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col cols="12">
                <v-divider></v-divider>

                <label for="">Bimestre</label>
                <v-input>
                  {{ plano.bimestre ? plano.bimestre.descricao : "Sem Descrição" }}
                </v-input>
              </v-col>
            </v-row> -->

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for=""
                  >COMPETÊNCIAS ESPECÍFICAS DA DISCIPLINA PARA O ENSINO FUNDAMENTAL</label
                >
                <v-input filled rounded dense color="primary">
                  <div
                    v-html="formatarQuebraLinha(plano.competencia_disciplina_ensino_fundamental)"
                  ></div>
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for="">EMENTA</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.ementa)"></div>
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for="">UNIDADES TEMÁTICAS</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.unidades_tematicas)"></div>
                </v-input>
              </v-col>
            </v-row>

            <!-- Conteúdo | Assunto | Objetos de conhecimento  -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>OBJETOS DO CONHECIMENTO</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.objetos_conhecimento)"></div>
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>HABILIDADES</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.habilidades)"></div>
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>DESCRITORES SAEB / SAEPI</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.descritores)"></div>
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>METODOLOGIA</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.metodologia)"></div>
                </v-input>
              </v-col>
            </v-row>

            <!-- RECURSOS DIDÁTICOS -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>RECURSOS DIDÁTICOS</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.recursos_didaticos)"></div>
                </v-input>
              </v-col>
            </v-row>

            <!-- AVALIAÇÃO DA APRENDIZAGEM -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>AVALIAÇÃO</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.avaliacao)"></div>
                </v-input>
              </v-col>
            </v-row>

            <!-- REFERÊNCIAS -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label>REFERÊNCIAS</label>
                <v-input filled rounded dense color="primary">
                  <div v-html="formatarQuebraLinha(plano.referencias)"></div>
                </v-input>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialog" :pdf="pdf" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalPlanoAnual.vue";

export default {
  components: {
    ModalCarteira,
  },
  data() {
    return {
      dialog: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      habilidadeSelecionadas: [],
      recursosSelecionados: [],
      avaliacoesSelecionadas: [],
      duvidasSelecionadas: [],
    };
  },
  async mounted() {
    await this.getId();
    await this.listarPlano(this.pageNumber);
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosAnuaisService.show(this.plano_id);
        this.plano = { ...data.planoMensal };
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosAnuaisService.pdf(planoId);
    },
    formatarQuebraLinha(texto) {
      if (!texto) return "- - -";
      return texto.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style></style>
